import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFirestore } from "angularfire2/firestore";
import { isEmpty, toArray } from "lodash";
import { Observable } from "rxjs/Observable";
import { combineLatest } from "rxjs/observable/combineLatest";
import { map, switchMap } from "rxjs/operators";
import { IVoting, IVotingPonderation, IVotingQuestions } from "../shared/models/voting.model";
import { Utilities } from "./utilities";

@Injectable()
export class VotingData {

  constructor(
    private afDb: AngularFireDatabase,
    private afStore: AngularFirestore,
    private utilities: Utilities,
  ) { }

  public getVotingsByClient(client: string): Observable<IVoting[]> {
    return this.afDb.list<IVoting>(`Clients/${client}/Voting`).
      valueChanges();
  }

  public getVotingById(client: string, id: string): Observable<IVoting> {
    return this.afDb.object<IVoting>(`Clients/${client}/Voting/${id}`).
      valueChanges();
  }

  public createVoting(client: string, voting: IVoting) {
    if (voting.id === "") { voting.id = this.afDb.createPushId(); }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Voting/${voting.id}`)
        .update({ id: voting.id, general: voting })
        .then(() => {
          resolve(voting);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getQuestionByVotingId(client: string, id: string, questionId: string): Observable<IVotingQuestions> {
    return this.afDb.object<IVotingQuestions>(`Clients/${client}/Voting/${id}/questions/${questionId}`).
      valueChanges();

  }

  public updateQuestionByVotingId(client: string, id: string, question: IVotingQuestions): Observable<any> {
    if (question.id === "") { question.id = this.afDb.createPushId(); }
    return Observable.fromPromise(
      this.afDb.object(`Clients/${client}/Voting/${id}/questions/${question.id}`)
        .update(question));
  }

  public updatePonderationByVotingId(client: string, id: string, ponderation: IVotingPonderation): Observable<any> {
    return Observable.fromPromise(
      this.afDb.object(`Clients/${client}/Voting/${id}/ponderation/`)
        .update(ponderation));
  }

  public getVotingAnswers(clientId: string, votingId: string) {
    return this.afStore
      .collection(clientId)
      .doc("voting-answers")
      .collection(votingId)
      .valueChanges();
  }

  public getVotingEventAnswers(clientId: string, eventId: string, votingId: string) {
    return this.afStore.collection(clientId).doc("voting-events")
      .collection(votingId)
      .doc("event")
      .collection(eventId)
      .valueChanges();
  }

  public getVotingExcel(clientId: string, eventId: string, votingId: string) {
    this.utilities.consoleDecorator("stop here - client", clientId);
    return this.getVotingEventAnswers(clientId, eventId, votingId)
      .pipe(switchMap((votingAnswers: any) => {
        this.utilities.consoleDecorator("stop here - voting answers", votingAnswers);
        const obsAnswers = [];
        for (const votingAnswer of votingAnswers) {
          for (const answer of Object.keys(votingAnswer.answers)) {
            this.utilities.consoleDecorator("answer", answer);
            obsAnswers.push(this.getQuestionByVotingId(clientId, votingId, answer));
          }
        }
        combineLatest(obsAnswers);
        return (isEmpty(obsAnswers)) ? Observable.of({}) : combineLatest(obsAnswers)
          .pipe(map((data) => {

            const answers = [];
            let questionFromDB = [];
            let answersFromDB = [];

            for (const votingUserRecords of votingAnswers) {
              Object.keys(votingUserRecords.answers).forEach((answerKey) => {
                for (const item of data) {
                  if (item.id === answerKey) {
                    questionFromDB = item;
                    answersFromDB = toArray(item.answers).filter((itemAnswer) => {
                      return itemAnswer.id === votingUserRecords.answers[answerKey];
                    });
                  }
                }
                this.utilities.consoleDecorator("questionFromDB - answersFromDB", [questionFromDB, answersFromDB]);

                answers.push(
                  {
                    answer: (isEmpty(answersFromDB)) ? "Woops, respuesta no encontrada" : answersFromDB,
                    question: (isEmpty(questionFromDB)) ? "Woops, pregunta no encontrada" : questionFromDB,
                  });
              });
            }
            this.utilities.consoleDecorator("Combine Latest", answers);
            return answers;
          }));
      }));
  }

}



// WEBPACK FOOTER //
// ./src/providers/voting.ts